import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12,2C9.243,2,7,4.243,7,7v3H6c-1.104,0-2,0.896-2,2v8c0,1.104,0.896,2,2,2h2h3h2h2h3c1.104,0,2-0.896,2-2v-8 c0-1.104-0.896-2-2-2h-1V7C17,4.243,14.757,2,12,2z M9,7c0-1.654,1.346-3,3-3s3,1.346,3,3v3H9V7z M13,17.723V20h-2v-2.277 c-0.727-0.422-1.169-1.278-0.939-2.224c0.176-0.72,0.78-1.302,1.506-1.453C12.861,13.774,14,14.753,14,16 C14,16.739,13.596,17.377,13,17.723z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}